import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringEngagementsTab1Part } from './tabs/tab-1/volunteering-engagements-tab-1.part';
import { VolunteeringEngagementsTab2Part } from './tabs/tab-2/volunteering-engagements-tab-2.part';
import { VolunteeringEngagementsViewsPart } from './views/volunteering-engagements-views.part';
import { VolunteeringEngagementsService } from './volunteering-engagements.service';

@Component({
	selector: 'volunteering-engagements-page',
	standalone: true,
	imports: [
		VolunteeringEngagementsViewsPart,
		VolunteeringEngagementsTab1Part,
		VolunteeringEngagementsTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-engagements.page.html',
})
export class VolunteeringEngagementsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringEngagementsService);
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}